module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyCAMAAACd646MAAAApVBMVEXnABNzAAkAAAAQEBA0NDQdHR2xsbH8/Pzs7Oy3t7ecnJyQkJBNTU3x8fH09PRubm4BAQEeHh45OTkRERH7+/s2NjYTExOenp4PDw////+GhoYNDQ3AwMCmpqYcHBxtbW0iIiLi4uKOjo4nJyd6enrNzc0HBwcmJiZ5eXnMzMylpaUbGxtsbGwODg7w8PD19fVvb2+wsLC4uLidnZ0zMzMSTyMjnkadQukrAAAAqklEQVR4Ae3VAxIDQRBA0bVtxzbvf7M4KcbpifqvS289FIZh2DdGE4hiCPQDCCIsx7HACC+IkqyoPCSi6YZpbba2w7hQCK97/mE3CCMgRIiT426a5VZRKl6PuGJcPh1U4jiuAlwJF0uHvVq9sTGMJijSanegEPby7YJ48F2r1y+gX+EB2Mc4HI2hP0aGKSaiNJ2pBfQPcj5ncTy5LUQWBKKWBEIEEUQQeXFrDsAuLl9K930AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ly.png
// module id = 1XPQ
// module chunks = 0